import { render } from "./HCbutton.vue?vue&type=template&id=525edbe7&scoped=true"
const script = {}

import "./HCbutton.vue?vue&type=style&index=0&id=525edbe7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-525edbe7"

export default script